{
  "actionbar.actions": "Ενέργειες",
  "actionbar.actionsAvailable": "Υπάρχουν διαθέσιμες ενέργειες.",
  "actionbar.clearSelection": "Εκκαθάριση επιλογής",
  "actionbar.selected": "{count, plural, =0 {Δεν επιλέχθηκε κανένα} one {# επιλεγμένο} other {# επιλεγμένα}}",
  "actionbar.selectedAll": "Επιλέχθηκαν όλα",
  "actionbutton.pending": "σε εκκρεμότητα",
  "breadcrumbs.more": "Περισσότερα στοιχεία",
  "button.pending": "σε εκκρεμότητα",
  "calendar.invalidSelection": "{selectedCount, plural, one {Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη} other {Οι επιλεγμένες ημερομηνίες δεν είναι διαθέσιμες}}.",
  "combobox.loading": "Φόρτωση...",
  "combobox.loadingMore": "Φόρτωση περισσότερων...",
  "combobox.noResults": "Κανένα αποτέλεσμα",
  "contextualhelp.help": "Βοήθεια",
  "contextualhelp.info": "Πληροφορίες",
  "datepicker.endTime": "Χρόνος λήξης",
  "datepicker.startTime": "Ώρα έναρξης",
  "datepicker.time": "Χρόνος",
  "dialog.alert": "Ειδοποίηση",
  "dialog.dismiss": "Απόρριψη",
  "dropzone.replaceMessage": "Απόθεση αρχείου για αντικατάσταση",
  "inlinealert.informative": "Πληροφορίες",
  "inlinealert.negative": "Σφάλμα",
  "inlinealert.notice": "Προειδοποίηση",
  "inlinealert.positive": "Επιτυχία",
  "label.(optional)": "(προαιρετικό)",
  "label.(required)": "(απαιτείται)",
  "listview.loading": "Φόρτωση...",
  "listview.loadingMore": "Φόρτωση περισσότερων...",
  "menu.loading": "Φόρτωση...",
  "menu.loadingMore": "Φόρτωση περισσότερων...",
  "menu.moreActions": "Περισσότερες ενέργειες",
  "menu.noResults": "Κανένα αποτέλεσμα",
  "menu.unavailable": "Μη διαθέσιμο, ανάπτυξη για λεπτομέρειες",
  "notificationbadge.indicatorOnly": "Νέα δραστηριότητα",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Φόρτωση...",
  "picker.loadingMore": "Φόρτωση περισσότερων...",
  "picker.placeholder": "Επιλογή…",
  "picker.selectedCount": "{count, plural, =0 {Δεν επιλέχθηκαν στοιχεία} one {Επιλέχθηκε # στοιχείο} other {Επιλέχθηκαν # στοιχεία}}",
  "sidepanel.collapse": "Σύμπτυξη πλευρικού πλαισίου",
  "sidepanel.expand": "Επέκταση πλευρικού πλαισίου",
  "slider.maximum": "Μέγιστο",
  "slider.minimum": "Ελάχιστο",
  "table.cancel": "Ακύρωση",
  "table.drag": "Μεταφορά",
  "table.editCell": "Επεξεργασία κελιού",
  "table.loading": "Φόρτωση...",
  "table.loadingMore": "Φόρτωση περισσότερων...",
  "table.resizeColumn": "Αλλαγή μεγέθους στήλης",
  "table.save": "Αποθήκευση",
  "table.sortAscending": "Ταξινόμηση κατά αύξουσα σειρά",
  "table.sortDescending": "Ταξινόμηση κατά φθίνουσα σειρά",
  "tag.actions": "Ενέργειες",
  "tag.hideButtonLabel": "Εμφάνιση λιγότερων",
  "tag.noTags": "Κανένα",
  "tag.showAllButtonLabel": "Εμφάνιση όλων ({tagCount, number})",
  "toast.clearAll": "Εκκαθάριση όλων",
  "toast.collapse": "Σύμπτυξη",
  "toast.showAll": "Εμφάνιση όλων",
  "treeview.loadingMore": "Φόρτωση περισσότερων..."
}
